import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const GoodsSkuCategoryIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [goodsSkuCategoryPageIndex, setGoodsSkuCategoryPageIndex] = useState(1);
    const [goodsSkuCategoryPageSize, setGoodsSkuCategoryPageSize] = useState(store.main.pageSize);
    const [goodsSkuCategoryIdList, setGoodsSkuCategoryIdList] = useState([]);
    const [goodsSkuCategoryTotal, setGoodsSkuCategoryTotal] = useState(0);
    const [goodsSkuCategoryList, setGoodsSkuCategoryList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/goods/sku/category/index"});

            handleSearchGoodsSkuCategory();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadGoodsSkuCategory(goodsSkuCategoryPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadGoodsSkuCategory(goodsSkuCategoryPageIndex, goodsSkuCategoryPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchGoodsSkuCategory = () => {
        handleLoadGoodsSkuCategory(1, goodsSkuCategoryPageSize);
    };

    const handleLoadGoodsSkuCategory = (goodsSkuCategoryPageIndex, goodsSkuCategoryPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = goodsSkuCategoryPageIndex;
        data.pageSize = goodsSkuCategoryPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/goods/sku/category/business/website/v1/list",
            data: data,
            success: (response) => {
                setGoodsSkuCategoryPageIndex(goodsSkuCategoryPageIndex);
                setGoodsSkuCategoryPageSize(goodsSkuCategoryPageSize);
                setGoodsSkuCategoryIdList([]);
                setGoodsSkuCategoryTotal(response.data.total);
                setGoodsSkuCategoryList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddGoodsSkuCategory = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/goods/sku/category/add",
        });
    };

    const handleEditGoodsSkuCategory = (goodsSkuCategoryId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/goods/sku/category/edit/" + goodsSkuCategoryId,
        });
    };

    const handleDelGoodsSkuCategory = () => {
        if (goodsSkuCategoryIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/goods/sku/category/business/website/v1/delete",
                    data: {
                        goodsSkuCategoryIdList: goodsSkuCategoryIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setGoodsSkuCategoryIdList([]);

                        handleLoadGoodsSkuCategory(goodsSkuCategoryPageIndex, goodsSkuCategoryPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeGoodsSkuCategoryIdList = (goodsSkuCategoryIdList) => {
        setGoodsSkuCategoryIdList(goodsSkuCategoryIdList);
    };

    const handleChangeGoodsSkuCategoryPagination = (goodsSkuCategoryPageIndex, goodsSkuCategoryPageSize) => {
        handleLoadGoodsSkuCategory(goodsSkuCategoryPageIndex, goodsSkuCategoryPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddGoodsSkuCategory}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={goodsSkuCategoryIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelGoodsSkuCategory}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchGoodsSkuCategory}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="分类名称"
                                labelAlign={"left"}
                                name="goodsSkuCategoryName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入分类名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入分类名称" onPressEnter={handleSearchGoodsSkuCategory} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.goodsSkuCategoryId}
                        columns={[
                            {
                                title: "分类名称",
                                dataIndex: "goodsSkuCategoryName",
                            },
                            {
                                title: "分类排序",
                                dataIndex: "goodsSkuCategorySort",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button
                                            icon={<FileTextOutlined />}
                                            size="default"
                                            onClick={() => handleEditGoodsSkuCategory(record.goodsSkuCategoryId)}
                                        >
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={goodsSkuCategoryList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: goodsSkuCategoryIdList,
                            onChange: handleChangeGoodsSkuCategoryIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: goodsSkuCategoryPageIndex,
                            pageSize: goodsSkuCategoryPageSize,
                            total: goodsSkuCategoryTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeGoodsSkuCategoryPagination,
                            onShowSizeChange: handleChangeGoodsSkuCategoryPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

GoodsSkuCategoryIndex.propTypes = {};

GoodsSkuCategoryIndex.defaultProps = {};

export default GoodsSkuCategoryIndex;
